module.exports = __webpack_public_path__ + "img/email.32318955.svg";